<template>
    <div >
        <div class="px-1">
            <div class="dashboard">
                <div class="row px-1">
                    <div class="item bg-gradient-info col-12 p-2" :class="`col-md-${projetoIniciado ? 6 : 12}`">
                        <img src="@/assets/images/lines.svg" class="card-img-absolute" alt="circle-image">
                        <div class="text-center">Valor total <b-badge variant="light">Previsto</b-badge></div>
                        <h4 class="mt-2 text-center text-white">{{totalPrevisto}}</h4>
                    </div>
                    <div class="item bg-gradient-success col-12 col-md-6 p-2" v-if="projetoIniciado">
                        <img src="@/assets/images/lines.svg" class="card-img-absolute" alt="circle-image">
                        <div class="text-center">Valor total <b-badge variant="light">Realizado</b-badge></div>
                        <h4 class="mt-2 text-center text-white">{{totalRealizado}}</h4>
                    </div>
                </div>            
            </div>
        </div>
        <accordion
            :title="dados.atividade"
            v-for="(dados,i) in itens"
            :key="i"
            :id="`atividade_${i}`"
            sub
            :accordion="`atividade_${i}`"
        >
            <template #append-title>
                <div class="d-flex">
                    <div class="ml-4 w300">
                        <b-badge class="mr-2 bg-blue-300" >Valor previsto</b-badge>
                        <span class="text-blue-300">{{formatarValor(dados.dados[0].totalPrevisto)}}</span>
                    </div>
                    <div class="ml-2 w300 " v-if="projetoIniciado">
                        <b-badge class="mr-2 bg-green-300">Valor realizado</b-badge>
                        <span class="text-green-300">{{formatarValor(dados.dados[1].totalPrevisto)}}</span>
                    </div>
                </div>
            </template>
            <div class="row px-3 pt-3">
                <div class="col-12">
                    <span class="h5 text-info">
                        {{dados.atividade}}                        
                    </span>
                </div>
                <p class="col-12">
                    {{dica(dados.atividade).tipo}}
                </p>
                <div class="col-12">
                    <b-badge pill class="mr-1 px-1" v-for="categoria in dica(dados.atividade).categoria" :key="categoria">
                        {{categoria}}
                    </b-badge>
                </div>
            </div>
            <hr>
            <div class="row px-3">
                <div class="col-12">
                    <b-badge variant="info">Previsto</b-badge>
                </div>
                <div class="col-12 h4">{{formatarValor(dados.dados[0].totalPrevisto)}}</div>
                <div class="col-12"><b-badge variant="danger">Custos</b-badge></div>
                <div class="col-12 text-red-500" v-for="debito,i in dados.dados[0].detalhamento" :key="`debito${i}`">
                    <span>
                        {{debito.rubrica}} - 
                    </span>
                    <span class="float-right">
                        {{formatarValor(debito.custo)}}
                    </span>
                </div>
                <input-textarea :disabled="!projetoEditavel" class="col-12" label="Descrição" :readonly="readonly" v-if="!projetoIniciado" v-model="dados.dados[0].descricao" @changed="liberarSalvar(dados)" @blur="salvarAtividade(dados)" />
                <div class="col-12">
                    <b-badge v-if="projetoIniciado">Descrição</b-badge>

                </div>
                <p class="col-12" v-if="projetoIniciado">{{dados.dados[0].descricao || 'Sem descrição...'}}</p>
            </div>
            <hr>
            <div class="row px-3" v-if="projetoIniciado">
                <div class="col-12">
                    <b-badge variant="info">Realizado</b-badge>
                </div>
                <div class="col-12 h4">{{formatarValor(dados.dados[1].totalPrevisto)}}</div>
                <div class="col-12"><b-badge variant="danger">Custos</b-badge></div>
                <div class="col-12 text-red-500" v-for="debito,i in dados.dados[1].detalhamento" :key="`debito${i}`">
                    <span>
                        {{debito.rubrica}} - 
                    </span>
                    <span class="float-right">
                        {{formatarValor(debito.custo)}}
                    </span>
                </div>
                <input-textarea :disabled="!projetoEditavel"  label="Descrição" class="col-12" :readonly="readonly" v-model="dados.dados[1].descricao" @changed="liberarSalvar(dados)" @blur="salvarAtividade(dados)" />
            </div>
        </accordion>
    </div>
</template>
<script>
import ProjetoGestaoService from '@/common/services/projeto_gestao/projeto_gestao.service';
import helpers from '@/common/utils/helpers';
import InputTextarea from '@/components/inputs/InputTextarea';
import {AlertasMixin} from '@/common/mixins/AlertasMixin';
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Accordion from "@/components/card/Accordion";
export default {
    name: 'ProjetoGestaoAtividades',
    mixins: [AlertasMixin],
    components: {
        InputTextarea,
        Accordion
    },
    props : {
        projeto: {
            type: Object,
            default: null
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data : () => ({
        slot : 'atividade',
        itens : [
            { atividade : "AC", endpoint : "ac", dados : { 0 : {}, 1 : {}} },
            { atividade : "AP", endpoint : "ap", dados : { 0 : {}, 1 : {}} },
            { atividade : "BA", endpoint : "ba", dados : { 0 : {}, 1 : {}} },
            { atividade : "CA", endpoint : "ca", dados : { 0 : {}, 1 : {}} },
            { atividade : "EC", endpoint : "ec", dados : { 0 : {}, 1 : {}} },
            { atividade : "FG", endpoint : "fg", dados : { 0 : {}, 1 : {}} },
            { atividade : "HH", endpoint : "hh", dados : { 0 : {}, 1 : {}} },
            { atividade : "PP", endpoint : "pp", dados : { 0 : {}, 1 : {}} },
            { atividade : "RP", endpoint : "rp", dados : { 0 : {}, 1 : {}} },
        ],
        colunas : [
            
        ],
    }),
    methods : {
        montarColunas : function(){
            this.colunas = [
                {key : "atividade", label : "Atividade"},
                {key : "dados.0.totalPrevisto", label : "Valor previsto",
                    formatter : (value) => {
                        if(value)
                            return helpers.formatarValor(value);
                        else
                            return helpers.formatarValor(0);
                    }
                },
                {key : "dados.0.descricao", label : "Descrição prevista"},
            ];
            if(this.projetoIniciado){
                this.colunas.push(
                    ...[                        
                        {key : "dados.1.totalPrevisto", label : "Valor realizado",
                            formatter : (value) => {
                                if(value)
                                    return helpers.formatarValor(value);
                                else
                                    return helpers.formatarValor(0);
                            }
                        },
                        {key : "dados.1.descricao", label : "Descrição realizado"},
                    ]
                );
            }
        },
        liberarSalvar : function(item){
            item.salvar = true;
        },
        buscarAtividades : function(realizado){
            let quantidade = this.itens.length;
            this.$store.dispatch(START_LOADING);
            this.itens.forEach(item => {
                ProjetoGestaoService.buscarAtividade(item.endpoint, realizado, !this.readonly ? this.projeto.id : this.projeto.projetoGestaoId).then(res => {
                    item.dados[realizado ? 1 : 0] = res.data.data;
                }).finally(() => {
                    quantidade--;
                    if(quantidade === 0){
                        this.$store.dispatch(STOP_LOADING);
                    }
                });
            });
        },
        salvarAtividade : function(atividade){
            if(atividade.salvar === undefined)
                return;

            this.$store.dispatch(START_LOADING);
            let form = {
                projetoGestaoId : this.projeto.id,
                descricao : atividade.dados[!this.projetoIniciado ? 0 : 1].descricao
            }
            ProjetoGestaoService.salvarAtividade(atividade.endpoint, this.projetoIniciado, form).then(() => {
                this.toast('Atividade salva com sucesso!', {variant : 'success'});
                this.buscarAtividades(this.projetoIniciado);
            }).catch(() => {
                this.toast('Erro ao salvar atividade!', {variant : 'danger'});
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        montar : function(){
            this.montarColunas();
            this.buscarAtividades(false);
            if(this.projetoIniciado)
            this.buscarAtividades(true);
        },
        dica : function(dica){
            return helpers.retornarDica(dica);
        },
        formatarValor : function(valor){
            return helpers.formatarValor(valor);
        },
    },
    mounted : function(){
        
    },
    computed : {
        projetoIniciado : function(){
            return this.projeto.faseRealizacao;
        },
        totalPrevisto : function(){
            return helpers.formatarValor(this.itens.reduce((total, item) => {
                return total + (item.dados[0].totalPrevisto ? item.dados[0].totalPrevisto : 0);
            }, 0));
        },
        totalRealizado : function(){
            return helpers.formatarValor(this.itens.reduce((total, item) => {
                return total + (item.dados[1].totalPrevisto ? item.dados[1].totalPrevisto : 0);
            }, 0));
        },
        readonly :function(){
            return this.$route.name != 'projeto-gestao-proponente-detalhamento' || !this.permissao.u;
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosGestaoAtividades');
        },
    }
}
</script>
<style>
    .atividades .card-header {
        background: #f3f2f2; border-bottom: 1px solid #e5e5e5;
    }

    .atividades .card-header-tabs{
        align-items: end;
    }
    .dashboard .item {
        border-right: 1px solid #e5e5e5;
        border-left: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
        font-size: 13px;    
        color: #FFF;
    }
    .card-img-absolute {
        position: absolute;
        top: 0;
        right: 0;
        height: 73px;
        width: 100%;
        object-fit: cover;
    }
    .w300{
        width: 300px;
    }
</style>